import { CMSLegalContent } from "@/pages/AboutAutoRenew";

export const fallbackAutoRenewContent: CMSLegalContent = {
  autoRenew: {
    title: "Unlock savings with Auto-Renew",
    text: "Automatically refill your IV Nutrient Pack when it runs low—no need to remember to repurchase. Stay consistent with your wellness routine and get exclusive savings when you enroll.",
    generalConditions: {
      root: {
        children: [
          {
            children: [
              {
                detail: 0,
                format: 1,
                mode: "normal",
                style: "",
                text: "General Conditions for autorenewal:",
                type: "text",
                version: 1,
              },
            ],
            direction: "ltr",
            format: "",
            indent: 0,
            type: "paragraph",
            version: 1,
            textFormat: 0,
            textStyle: "",
          },
          {
            children: [
              {
                type: "linebreak",
                version: 1,
              },
              {
                detail: 0,
                format: 1,
                mode: "normal",
                style: "",
                text: "Membership Status:",
                type: "text",
                version: 1,
              },
              {
                detail: 0,
                format: 0,
                mode: "normal",
                style: "",
                text: " The membership must be in an active or paid status to be eligible for freezing. Memberships that are already expired, canceled, or in a pending cancellation state cannot be frozen.",
                type: "text",
                version: 1,
              },
            ],
            direction: "ltr",
            format: "",
            indent: 0,
            type: "paragraph",
            version: 1,
            textFormat: 1,
            textStyle: "",
          },
          {
            children: [],
            direction: "ltr",
            format: "",
            indent: 0,
            type: "paragraph",
            version: 1,
            textFormat: 0,
            textStyle: "",
          },
          {
            type: "linebreak",
            version: 1,
          },
          {
            children: [
              {
                detail: 0,
                format: 1,
                mode: "normal",
                style: "",
                text: "Account Standing:",
                type: "text",
                version: 1,
              },
              {
                detail: 0,
                format: 0,
                mode: "normal",
                style: "",
                text: " The member's account must be in good standing. This could mean no outstanding payments, no active violations of terms of service, etc.",
                type: "text",
                version: 1,
              },
              {
                type: "linebreak",
                version: 1,
              },
              {
                type: "linebreak",
                version: 1,
              },
              {
                detail: 0,
                format: 1,
                mode: "normal",
                style: "",
                text: "Freeze Availability:",
                type: "text",
                version: 1,
              },
              {
                detail: 0,
                format: 0,
                mode: "normal",
                style: "",
                text: " The membership type might determine if freezing is allowed. For example, certain promotional or heavily discounted memberships might not be eligible for freezing.",
                type: "text",
                version: 1,
              },
              {
                type: "linebreak",
                version: 1,
              },
              {
                type: "linebreak",
                version: 1,
              },
              {
                detail: 0,
                format: 1,
                mode: "normal",
                style: "",
                text: "Freeze Frequency:",
                type: "text",
                version: 1,
              },
              {
                detail: 0,
                format: 0,
                mode: "normal",
                style: "",
                text: " There might be a limit on how often a membership can be frozen within a specific period (e.g., once per year).",
                type: "text",
                version: 1,
              },
              {
                type: "linebreak",
                version: 1,
              },
              {
                type: "linebreak",
                version: 1,
              },
              {
                detail: 0,
                format: 1,
                mode: "normal",
                style: "",
                text: "Minimum Membership Duration:",
                type: "text",
                version: 1,
              },
              {
                detail: 0,
                format: 0,
                mode: "normal",
                style: "",
                text: " A member might need to have been active for a certain minimum period before being eligible to freeze their membership (e.g., active for at least one full billing cycle).",
                type: "text",
                version: 1,
              },
              {
                type: "linebreak",
                version: 1,
              },
              {
                type: "linebreak",
                version: 1,
              },
              {
                detail: 0,
                format: 1,
                mode: "normal",
                style: "",
                text: "Conditions Related to Freeze Duration:",
                type: "text",
                version: 1,
              },
              {
                type: "linebreak",
                version: 1,
              },
              {
                type: "linebreak",
                version: 1,
              },
              {
                detail: 0,
                format: 0,
                mode: "normal",
                style: "",
                text: "Predefined Durations: The application should only allow the user to select a freeze duration of exactly 30, 60, or 90 days. No other durations should be permitted.",
                type: "text",
                version: 1,
              },
              {
                type: "linebreak",
                version: 1,
              },
              {
                type: "linebreak",
                version: 1,
              },
              {
                detail: 0,
                format: 0,
                mode: "normal",
                style: "",
                text: "Maximum Freeze Period: The total cumulative freeze time within a specific period (e.g., a year) might have a maximum limit, even if individual freezes are within the 90-day limit.",
                type: "text",
                version: 1,
              },
              {
                type: "linebreak",
                version: 1,
              },
              {
                type: "linebreak",
                version: 1,
              },
              {
                detail: 0,
                format: 0,
                mode: "normal",
                style: "",
                text: "Single Freeze at a Time: Only one active freeze period should be allowed at any given time per membership. A new freeze cannot be initiated while a previous one is still active.",
                type: "text",
                version: 1,
              },
              {
                type: "linebreak",
                version: 1,
              },
              {
                type: "linebreak",
                version: 1,
              },
              {
                detail: 0,
                format: 0,
                mode: "normal",
                style: "",
                text: "No Partial Freezing: The membership must be frozen for a continuous block of 30, 60, or 90 days. Partial freezing or breaking up the freeze period is not allowed.",
                type: "text",
                version: 1,
              },
              {
                type: "linebreak",
                version: 1,
              },
              {
                type: "linebreak",
                version: 1,
              },
              {
                detail: 0,
                format: 0,
                mode: "normal",
                style: "",
                text: "Conditions Regarding the Freeze Process:",
                type: "text",
                version: 1,
              },
              {
                type: "linebreak",
                version: 1,
              },
              {
                type: "linebreak",
                version: 1,
              },
              {
                detail: 0,
                format: 0,
                mode: "normal",
                style: "",
                text: "User Initiation: The freeze request must be initiated by the member through the application interface.",
                type: "text",
                version: 1,
              },
              {
                type: "linebreak",
                version: 1,
              },
              {
                type: "linebreak",
                version: 1,
              },
              {
                detail: 0,
                format: 0,
                mode: "normal",
                style: "",
                text: "Confirmation: The application should require the member to confirm their freeze request and acknowledge the implications of freezing (e.g., access restrictions during the freeze).",
                type: "text",
                version: 1,
              },
              {
                type: "linebreak",
                version: 1,
              },
              {
                type: "linebreak",
                version: 1,
              },
              {
                detail: 0,
                format: 0,
                mode: "normal",
                style: "",
                text: "Start Date: The freeze should ideally start on a specified date chosen by the user, potentially with some restrictions (e.g., cannot be in the past, must be within a certain timeframe). Alternatively, it could start immediately upon confirmation.",
                type: "text",
                version: 1,
              },
              {
                type: "linebreak",
                version: 1,
              },
              {
                type: "linebreak",
                version: 1,
              },
              {
                detail: 0,
                format: 0,
                mode: "normal",
                style: "",
                text: "Automatic Unfreeze: The membership should automatically resume on the day following the selected freeze duration (30, 60, or 90 days).",
                type: "text",
                version: 1,
              },
              {
                type: "linebreak",
                version: 1,
              },
              {
                type: "linebreak",
                version: 1,
              },
              {
                detail: 0,
                format: 0,
                mode: "normal",
                style: "",
                text: "Notification: The application should notify the member upon successful freezing and again before the membership is automatically unfrozen.",
                type: "text",
                version: 1,
              },
              {
                type: "linebreak",
                version: 1,
              },
              {
                type: "linebreak",
                version: 1,
              },
              {
                detail: 0,
                format: 0,
                mode: "normal",
                style: "",
                text: "Billing Implications: Clearly communicate the billing implications of freezing. For example:",
                type: "text",
                version: 1,
              },
              {
                type: "linebreak",
                version: 1,
              },
              {
                type: "linebreak",
                version: 1,
              },
              {
                detail: 0,
                format: 0,
                mode: "normal",
                style: "",
                text: "Billing should be paused during the freeze period.",
                type: "text",
                version: 1,
              },
              {
                type: "linebreak",
                version: 1,
              },
              {
                detail: 0,
                format: 0,
                mode: "normal",
                style: "",
                text: "The billing cycle might be adjusted upon unfreezing to account for the frozen time.",
                type: "text",
                version: 1,
              },
              {
                type: "linebreak",
                version: 1,
              },
              {
                detail: 0,
                format: 0,
                mode: "normal",
                style: "",
                text: "The next billing date will be shifted by the duration of the freeze.",
                type: "text",
                version: 1,
              },
              {
                type: "linebreak",
                version: 1,
              },
              {
                detail: 0,
                format: 0,
                mode: "normal",
                style: "",
                text: "Access Restrictions: Clearly state what features and access will be restricted during the freeze period.",
                type: "text",
                version: 1,
              },
              {
                type: "linebreak",
                version: 1,
              },
              {
                type: "linebreak",
                version: 1,
              },
              {
                detail: 0,
                format: 0,
                mode: "normal",
                style: "",
                text: "Example Implementation Considerations:",
                type: "text",
                version: 1,
              },
              {
                type: "linebreak",
                version: 1,
              },
              {
                type: "linebreak",
                version: 1,
              },
              {
                detail: 0,
                format: 0,
                mode: "normal",
                style: "",
                text: "Use dropdown menus or radio buttons in the application interface to restrict the user's choice of freeze duration to 30, 60, or 90 days.",
                type: "text",
                version: 1,
              },
              {
                type: "linebreak",
                version: 1,
              },
              {
                detail: 0,
                format: 0,
                mode: "normal",
                style: "",
                text: "Implement server-side validation to ensure the selected duration is valid and all other conditions are met before processing the freeze request.",
                type: "text",
                version: 1,
              },
              {
                type: "linebreak",
                version: 1,
              },
              {
                detail: 0,
                format: 0,
                mode: "normal",
                style: "",
                text: "Store the freeze start date and end date (calculated based on the selected duration) in the membership data.",
                type: "text",
                version: 1,
              },
              {
                type: "linebreak",
                version: 1,
              },
              {
                detail: 0,
                format: 0,
                mode: "normal",
                style: "",
                text: "Implement logic to check the freeze status before granting access to features.",
                type: "text",
                version: 1,
              },
              {
                type: "linebreak",
                version: 1,
              },
              {
                detail: 0,
                format: 0,
                mode: "normal",
                style: "",
                text: "Schedule a process to automatically update the membership status to active after the freeze period ends.",
                type: "text",
                version: 1,
              },
              {
                type: "linebreak",
                version: 1,
              },
            ],
            direction: "ltr",
            format: "",
            indent: 0,
            type: "paragraph",
            version: 1,
            textFormat: 1,
            textStyle: "",
          },
        ],
        direction: "ltr",
        format: "",
        indent: 0,
        type: "root",
        version: 1,
        textFormat: 1,
      },
    },
  },
};
